import React from 'react';
import { simplifiedAuthStyles } from '../../styles/simplifiedAuth';
import { Grid, Paper, useMediaQuery, useTheme } from '@mui/material';
import { PaperContainerProps } from '../PaperContainer';

const PaperContainerLayout = ({ variant, children, className }: PaperContainerProps): React.JSX.Element => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { classes } = simplifiedAuthStyles();
  const variantConfig = variant === 'small' ? 6 : variant === 'medium' ? 9 : 12;
  const documentTitle = document.title?.split('|')[0];

  return (
    <Grid container justifyContent="center" className={classes.container}>
      <Grid item xs={lgUp ? variantConfig : 12} className={classes.grid}>
        <Paper
          role="region"
          aria-label={documentTitle}
          className={`${!lgUp && classes.fullHeight} ${className}`}
          elevation={lgUp ? 1 : 0}>
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PaperContainerLayout;
